import { PermissionCode } from "@/constants/permissions";
import { AppRoutes } from "@/constants/routes";
import { Flex, Link } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Permiso } from "@/pages/role-asignation/schema/role-assignation.schema";

interface Props {
  permissions: Permiso[];
}

export const ConfigView = ({ permissions }: Props) => {
  const navigate = useNavigate();

  const hasAccess = (codigo: string) =>
    permissions?.some((p) => p.codigo === codigo && p.tipoPermiso === "R");

  const canUseDayMarket =
    hasAccess(PermissionCode.MARKET_CONFIG);

  const canUseRequestPolicies =
    hasAccess(PermissionCode.BUSINESS_POLICY);

  const canUseMotives =
    hasAccess(PermissionCode.MOTIVES);

  const canUseRelationFields =
    hasAccess(PermissionCode.FAMILY_RELATIONS_FIELDS);

  const canUseFinancialMovementsDesc =
    hasAccess(PermissionCode.FINANCIAL_MOVEMENTS_DESC);

  return (
    <Flex flexDir="column" paddingX={2} paddingY={1} gap="10px">
      {canUseDayMarket && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.PRICE_BOARD)}>
          Mercado del día
        </Link>
      )}
      {canUseRequestPolicies && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.REQUEST_POLICIES)}
        >
          Políticas de negocio
        </Link>
      )}
      {canUseMotives && (
        <Link variant="plain" onClick={() => navigate(AppRoutes.MOTIVES)}>
          Motivos
        </Link>
      )}
      {canUseRelationFields && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.RELATION_FIELDS)}
        >
          Campos relaciones familiares
        </Link>
      )}
      {canUseFinancialMovementsDesc && (
        <Link
          variant="plain"
          onClick={() => navigate(AppRoutes.FINANCIAL_MOVEMENTS_DESC)}
        >
          Relación comprobantes
        </Link>
      )}
    </Flex>
  );
};
